const Spacer = {
  isComponent: el => el.tagName === 'V-SPACER' ||
    (el.tagName === 'DIV' && el.classList.contains('spacer')),
  model: {
    defaults: Object.assign({}, {
      tagName: 'div',
      draggable: true,
      droppable: true,
      copyable: true,
      attributes: {
        id: 'spacer'
      },
      traits: [
        {
          name: 'id',
          label: 'ID',
          placeholder: 'ID',
          type: 'text'
        }
      ]
    })
  }
}

export default Spacer
